import { directives } from 'src/directives'
import type { App, Directive } from 'vue'

export interface RegisterCustomDirective {
  name: string
  directive: Directive
}

export const installCustomDirectives = (app: App) => {
  directives.forEach(({ name, directive }) => {
    app.directive(name, directive)
  })
}
